module.exports = __webpack_public_path__ + "img/danghuan-logo.fe04706f.png";